import { createSelector } from '@ngrx/store';
import { idtFeature } from './idt.reducer';

export const {
  selectIdtState,
  selectIdentite,
  selectLoading: selectIdtLoading,
  selectError: selectIdtError,
} = idtFeature;

export const selectCodeApprenant = createSelector(
  selectIdentite,
  (identite) => identite?.profilApprenant?.codeApprenant ?? null,
);

export const selectIneMaitre = createSelector(
  selectIdentite,
  (identite) => identite?.profilApprenant?.ineMaitre ?? null,
);
